import axios from 'axios'
import config from '../variables/config'

export const PLAYONLY_REQUIRED = 'bookedit/PLAYONLY_REQUIRED'
export const PARTY_REQUIRED = 'bookedit/PARTY_REQUIRED'
export const CLASS_REQUIRED = 'bookedit/CLASS_REQUIRED'
export const NOT_REQUIRED = 'bookedit/NOT_REQUIRED'
export const REQUEST_FINISHED = 'bookedit/REQUEST_FINISHED'
export const REQUEST_FAILED = 'bookedit/REQUEST_FAILED'
export const REQUEST_SENT = 'bookedit/REQUEST_SENT'
export const CHANGE_FINISHED = 'bookedit/CHANGE_FINISHED'

const initialState = {
  partyObj: {},
  playonlyObj: {},
  classObj: {},
  partyEditOn: false,
  playonlyEditOn: false,
  classEditOn: false,
  requestFailed: false,
  requestLoading: false,
  requestFinished: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYONLY_REQUIRED:
      return {
        ...state,
        playonlyObj: action.playonlyObj,
        playonlyEditOn: true
      }

    case PARTY_REQUIRED:
      return {
        ...state,
        partyObj: action.partyObj,
        partyEditOn: true
      }

    case CLASS_REQUIRED:
      return {
        ...state,
        classObj: action.classObj,
        classEditOn: true
      }

    case NOT_REQUIRED:
      return {
        ...state,
        partyObj: {},
        playonlyObj: {},
        classObj: {},
        partyEditOn: false,
        playonlyEditOn: false,
        classEditOn: false
      }

    case REQUEST_FINISHED:
      return {
        ...state,
        requestLoading: false,
        requestFinished: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_SENT:
      return {
        ...state,
        requestLoading: true
      }

    case CHANGE_FINISHED:
      return {
        ...state,
        requestFailed: false,
        requestFinished: false
      }

    default:
      return state
  }
}

export const playonlyEdit = obj => {
  return (dispatch, getState) => {
    dispatch({
      type: PLAYONLY_REQUIRED,
      playonlyObj: obj
    })
  }
}

export const classEdit = obj => {
  return (dispatch, getState) => {
    dispatch({
      type: CLASS_REQUIRED,
      classObj: obj
    })
  }
}

export const partyEdit = obj => {
  return dispatch => {
    dispatch({
      type: PARTY_REQUIRED,
      partyObj: obj
    })
  }
}

export const editFinished = obj => {
  return dispatch => {
    dispatch({
      type: NOT_REQUIRED
    })
  }
}

export const updateBooking = data => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const token = state.admin.token
      if (!data.id || !data.properties || !data.type) return

      dispatch({ type: REQUEST_SENT })
      const url =
        config.serverURL +
        '/' +
        data.type.slice(0, -1) +
        config.endpoint +
        '/' +
        data.id +
        '?access_token=' +
        token

      await axios.patch(url, data.properties)
      if (data.type === 'PlayOnlyBookings') {
        const quantities = {
          under12mnths: data.properties.visitorDetails.under12mnths.length,
          oneYearOlds: data.properties.visitorDetails.oneYearOlds.length,
          twoToThree: data.properties.visitorDetails.twoToThree.length,
          fourAndOver: data.properties.visitorDetails.fourAndOver.length,
          adults: data.properties.visitorDetails.adults.length,
          playAndEat1to2: data.properties.visitorDetails.playAndEat1to2.length,
          playAndEat3andOver:
            data.properties.visitorDetails.playAndEat3andOver.length
        }
        const emailToAdmin = {
          email: 'admin@wackykingdom.com',
          bookingRefNo: data.id + ' ' + data.properties.note,
          paymentDate: 'Old Time ' + JSON.stringify(data.properties.oldDate),
          note: data.properties.note + ' Old Note: ' + data.properties.oldNote,
          name:
            data.properties.visitorDetails.adults.length > 0
              ? data.properties.visitorDetails.adults[0].firstName +
                ' ' +
                data.properties.visitorDetails.adults[0].lastName
              : '',
          ticketDate: JSON.stringify(data.properties.date),
          ticketTime: data.properties.time,
          ticketPrice: data.properties.price,
          quantities: quantities
        }
        // await axios.post(
        //   config.serverURL + '/sendOrderAdminUpdate' + '?access_token=' + token,
        //   emailToAdmin
        // )
      }
      if (data.type === 'PartyBookings') {
        const emailToAdmin = {
          deposit: data.properties.attendeeDetails.totalDeposit,
          email: data.properties.email
            ? data.properties.email
            : 'admin@wackykingdom.com',
          location: 'Redhill',
          bookingRefNo:
            data.id +
            ' Note: ' +
            data.properties.note +
            ' Old Note: ' +
            data.properties.oldNote,
          paymentDate: 'Old Time ' + JSON.stringify(data.properties.oldDate),
          name:
            'Birthday Child ' +
            data.properties.additionalDetails.whoIsPartyFor +
            'Old Deposit:' +
            data.properties.oldAttendeeDetails.totalDeposit,
          partyDetails: data.properties,
          themeItems: data.properties.themeItems.filter(
            item => item.quantity > 0
          ),
          extraItems: data.properties.extraItems.filter(
            item => item.quantity > 0
          ),
          partyPrice: '£' + data.properties.attendeeDetails.totalPrice / 100,
          partyDate: JSON.stringify(
            new Date(data.properties.partyDate)
          ).substring(1, 17)
        }
        // await axios.post(
        //   config.serverURL +
        //     '/sendPartyOrderAdminConfirmation' +
        //     '?access_token=' +
        //     token,
        //   emailToAdmin
        // )
      }

      if (data.type === 'ClassBookings') {
        const emailToAdmin = {
          email: 'admin@wackykingdom.com',
          bookingRefNo: data.type + ' Update ' + data.id,
          paymentDate: 'Old Time ' + JSON.stringify(data.properties.oldDate),
          note: data.properties.note + ' Old Note: ' + data.properties.oldNote,
          name: '',
          ticketDate: JSON.stringify(data.properties.classDate),
          ticketTime: data.properties.classTime,
          ticketPrice: data.properties.tickets.reduce(
            (a, b) => +a + +b.singleTicketPrice * b.quantity,
            0
          ),
          quantities: {}
        }
        await axios.post(
          config.serverURL +
            '/sendOrderConfirmation' +
            '?access_token=' +
            token,
          emailToAdmin
        )
      }

      dispatch({ type: REQUEST_FINISHED })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const deleteBooking = data => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const token = state.admin.token

      dispatch({ type: REQUEST_SENT })
      const url =
        config.serverURL +
        '/' +
        data.type.slice(0, -1) +
        config.endpoint +
        '/' +
        data.id +
        '?access_token=' +
        token
      await axios.delete(url)

      dispatch({ type: REQUEST_FINISHED })
    } catch (error) {
      dispatch({ type: REQUEST_FAILED })
    }
  }
}

export const changeFinished = state => {
  return dispatch => {
    dispatch({ type: CHANGE_FINISHED })
  }
}
